import { supabase } from "@/integrations/supabase/client";

type Grecaptcha = {
  ready: (cb: () => void) => void;
  execute: (siteKey: string, opts: { action: string }) => Promise<string>;
};

let siteKeyPromise: Promise<string | null> | null = null;
let scriptLoaded = false;

async function fetchSiteKey(): Promise<string | null> {
  if (!siteKeyPromise) {
    siteKeyPromise = supabase.functions
      .invoke("get-recaptcha-site-key")
      .then(({ data, error }) => {
        if (error || !data?.siteKey) return null;
        return data.siteKey as string;
      })
      .catch(() => null);
  }
  return siteKeyPromise;
}

function loadScript(siteKey: string): Promise<void> {
  return new Promise((resolve, reject) => {
    if (scriptLoaded || document.querySelector(`script[data-recaptcha="true"]`)) {
      scriptLoaded = true;
      return resolve();
    }
    const s = document.createElement("script");
    s.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
    s.async = true;
    s.defer = true;
    s.dataset.recaptcha = "true";
    s.onload = () => { scriptLoaded = true; resolve(); };
    s.onerror = () => reject(new Error("recaptcha load failed"));
    document.head.appendChild(s);
  });
}

export async function getRecaptchaToken(action: string): Promise<string | null> {
  const siteKey = await fetchSiteKey();
  if (!siteKey) return null;
  try {
    await loadScript(siteKey);
    const g = (window as unknown as { grecaptcha?: Grecaptcha }).grecaptcha;
    if (!g) return null;
    await new Promise<void>((r) => g.ready(r));
    return await g.execute(siteKey, { action });
  } catch {
    return null;
  }
}
